// The left menu's one remembered choice: wide, or narrowed to icons.
//
// The menu used to keep this to itself. The three-lines button in the header and the guided tour
// need it too (VT review 7/8: the button now narrows the menu instead of hiding it, and the tour
// widens it before it points at an item), so the value lives in the user store and this is where
// it is read from and written to the browser.

export const SIDEBAR_COLLAPSED_KEY = "vt-sidebar-collapsed";

// Widths the page body follows (index.css reads --sidebar-w).
export const SIDEBAR_WIDTH_WIDE = "256px";
export const SIDEBAR_WIDTH_ICONS = "72px";

/** Was the menu left narrowed to icons? False for a first visit: a new agent sees it wide. */
export const readSidebarCollapsed = (storage) => {
  try {
    return (storage || window.localStorage).getItem(SIDEBAR_COLLAPSED_KEY) === "1";
  } catch (e) {
    return false;
  }
};

/** Remember the choice. Never throws: a blocked store just forgets. */
export const writeSidebarCollapsed = (collapsed, storage) => {
  try {
    (storage || window.localStorage).setItem(SIDEBAR_COLLAPSED_KEY, collapsed ? "1" : "0");
  } catch (e) {
    /* nothing to do */
  }
};

export const sidebarWidth = (collapsed) => (collapsed ? SIDEBAR_WIDTH_ICONS : SIDEBAR_WIDTH_WIDE);
